document.addEventListener('crJQActivated', function (e) {
  console.log('__ Pickup Activated __ ')
  jqCR('body').on('click', '.cr-shipping-method', function(){
    console.log('click');
    console.log('remove pickup parameters');

    var attributes = {};
    attributes['Pickup_Information'] = '';
    attributes['Pickup_StoreID'] = '';
    attributes['_unixTimestamp'] = '';
    attributes['_formattedDate'] = '';

    attributes['Pickup_date'] = '';
    attributes['Pickup_time']  = '';
    attributes['Pickup_name']  = '';
    attributes['Pickup_phone']  = '';
    attributes['Pickup_extra1']  = '';
    attributes['Pickup_extra2']  = '';
    attributes['Pickup_extra3']  = '';
    attributes['Pickup_Store']  = '';
    attributes['pickup']  = '';

    storePickup.updateCartAttributes(attributes)

  })	  
})